"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subStringHTML = exports.parseHTML = void 0;
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Returns link url and target
 *
 * @param {*} props Sitecore Rich text field JSON response
 * @returns {string} HTML Parsed text response
 */
var parseHTML = props => (0, _lodash.isString)(props) ? (0, _htmlReactParser.default)(props) : (0, _htmlReactParser.default)(props.value);

/**
 * Returns react component and string of text in it
 *
 * @returns {{result: array, fullSentence: string}} HTML Parsed text response, fullSentence for passing just the text
 * @param parsedHTML{object|string} RichText from Sitecore
 * @param charSize{number} Number of characters to check
 */
exports.parseHTML = parseHTML;
var subStringHTML = exports.subStringHTML = function subStringHTML(parsedHTML) {
  var charSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var charactersLeft = charSize;
  var fullSentence = '';
  var result = (0, _lodash.map)(parsedHTML, eachItem => {
    var isObj = (0, _lodash.isObject)(eachItem);
    var newCopy = isObj ? Object.assign({}, eachItem) : eachItem;
    fullSentence = isObj ? fullSentence.concat((0, _lodash.get)(newCopy, 'props.children')) : fullSentence.concat(newCopy);
    if (charactersLeft === 0) {} else if (!(0, _lodash.isObject)(newCopy)) {
      if (newCopy.length >= charactersLeft) {
        newCopy = newCopy.substring(0, charactersLeft);
        charactersLeft = 0;
      } else {
        charactersLeft = charactersLeft - newCopy.length;
      }
      return newCopy;
    } else if (newCopy.props.children.length >= charactersLeft && !(0, _lodash.isObject)(newCopy.props.children)) {
      // Longer string than charactersLeft
      var subStr = newCopy.props.children.substring(0, charactersLeft);
      newCopy.props = Object.assign({}, newCopy.props, {
        children: subStr
      });
      charactersLeft = 0;
      return newCopy;
    } else {
      // Shorter string than charactersLeft
      charactersLeft = charactersLeft - newCopy.props.children.length;
      return newCopy;
    }
  });
  return {
    result,
    fullSentence
  };
};